import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ShareIcon from '@wix/da-ds/pkg/Icons/24x24/Share';
import { BiData, ClickShareBiEvent } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../../../../_helpers';
import { useCopyDeviationLinkClick } from '../../../../../utils/hooks/useCopyLinkClick';

import overlayStyles from '../../../../Helper/OverlayIcons.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  buttonClassName?: string;
  iconClassName?: string;
  textClassName?: string;
}

const ShareControl: React.FC<Props> = ({
  deviation,
  className,
  buttonClassName,
  iconClassName,
  textClassName,
}) => {
  const { t } = useTranslation();
  const { onCopyLinkClick } = useCopyDeviationLinkClick(deviation);

  return (
    <div className={className}>
      <TextButton
        size="medium"
        variant="main"
        className={classnames(buttonClassName, overlayStyles['icon-button'])}
        onClick={onCopyLinkClick}
        biData={BiData<ClickShareBiEvent>({
          evid: 355,
          typeid: getDeviationResourceType(deviation),
          itemid: deviation.deviationId,
          deviationid: deviation.deviationId,
        })}
        aria-label={t('deviationview.overlay.a11y.share')}
      >
        <ShareIcon
          size={IconSize.MEDIUM}
          withPadding={false}
          disableDefaultColors={true}
          className={classnames(overlayStyles['icon'], iconClassName)}
        />
        <span className={textClassName}>{t('share.copyLink')}</span>
      </TextButton>
    </div>
  );
};
ShareControl.displayName = 'ShareControl';

export default ShareControl;
